import { Box } from '@chakra-ui/react';

const ButtonContainer = ({ children }) => {
  return (
    <Box
      width="100%"
      height="auto"
      display="flex"
      flexDirection={['column-reverse', 'row']}
      justifyContent="flex-end"
      alignItems="flex-end"
      paddingTop="24px"
    >
      {children}
    </Box>
  );
};

export default ButtonContainer;
